<template>
  <div class="world_cup_page">
    <div class="word_cup_header_banner">
      <img src="./img/header_banner.png" />
    </div>

    <!--页面左侧飘浮导航条-->
    <div class="page_float_window">
      <ul>
        <li @click="changePanel(1)" :class="pagePanel === 1 ? 'active' : ''">
          <span><img src="./img/float_icon_01.png" /></span>
          <strong>赛事</strong>
        </li>
        <li @click="changePanel(2)" :class="pagePanel === 2 ? 'active' : ''">
          <span><img src="./img/float_icon_02.png" /></span>
          <strong>积分榜</strong>
        </li>
        <li @click="changePanel(3)" :class="pagePanel === 3 ? 'active' : ''">
          <span><img src="./img/float_icon_03.png" /></span>
          <strong>晋级图</strong>
        </li>
        <li
          @click="changePanel(4)"
          :class="pagePanel === 4 ? 'active' : ''"
          v-show="guessPanelToggle == 1"
        >
          <span><img src="./img/float_icon_04.png" /></span>
          <strong>竞猜</strong>
        </li>
      </ul>
    </div>

    <div class="page_item_title" id="pageItemTitle">
      <img
        :src="require(`./img/page_title_${pagePanel}.png`)"
        v-show="pagePanel < 4"
      />
      <img
        :src="require(`./img/page_title_${pagePanel}.png`)"
        v-show="pagePanel == 4 && guessPanelToggle == 1"
      />
    </div>

    <!--页面主体内容区域-->
    <div class="page_body">
      <div class="page_panel">
        <div class="page_content" v-show="pagePanel === 1">
          <!--精彩体育赛事标题-->
          <ul class="panel_title">
            <li
              @click="setMatchGroupTag('')"
              :class="matchGroupTag == '' ? 'active' : ''"
            >
              全部
            </li>
            <li
              @click="setMatchGroupTag('A')"
              :class="matchGroupTag == 'A' ? 'active' : ''"
            >
              A组
            </li>
            <li
              @click="setMatchGroupTag('B')"
              :class="matchGroupTag == 'B' ? 'active' : ''"
            >
              B组
            </li>
            <li
              @click="setMatchGroupTag('C')"
              :class="matchGroupTag == 'C' ? 'active' : ''"
            >
              C组
            </li>
            <li
              @click="setMatchGroupTag('D')"
              :class="matchGroupTag == 'D' ? 'active' : ''"
            >
              D组
            </li>
            <li
              @click="setMatchGroupTag('E')"
              :class="matchGroupTag == 'E' ? 'active' : ''"
            >
              E组
            </li>
            <li
              @click="setMatchGroupTag('F')"
              :class="matchGroupTag == 'F' ? 'active' : ''"
            >
              F组
            </li>
            <li
              @click="setMatchGroupTag('G')"
              :class="matchGroupTag == 'G' ? 'active' : ''"
            >
              G组
            </li>
            <li
              @click="setMatchGroupTag('H')"
              :class="matchGroupTag == 'H' ? 'active' : ''"
            >
              H组
            </li>
          </ul>

          <!--周一至周日-->
          <dl class="change_week_row">
            <dt @click="getMatchWeeks('prev')">
              <img src="./img/icon_arrow_left.png" />
            </dt>
            <dd>
              <ul class="week_days" :style="`left:${weekScrollLeft}`">
                <li
                  v-for="(item, index) of matchWeeks"
                  :key="index"
                  @click.stop="setChangeWeek(index)"
                  :class="selectedWeekIndex === index ? 'active' : ''"
                >
                  <h3>{{ item.week }}</h3>
                  <p v-if="selectedWeekIndex == index && currentMatchTotal > 0">
                    ({{ currentMatchTotal }}场比赛)
                  </p>
                  <p v-else>{{ item.monthDay }}</p>
                </li>
              </ul>
            </dd>
            <dt @click="getMatchWeeks('next')">
              <img src="./img/icon_arrow_right.png" />
            </dt>
          </dl>

          <!--精彩体育赛事列表-->
          <div class="panel_content">
            <!--页面内容块中的加载动画-->
            <div class="loading_mask" v-show="loading">
              <div class="loading_anim">
                <img src="../../assets/img/loading-2.gif" />
              </div>
            </div>

            <!--列表内容-->
            <div class="panel_match_list" v-if="matchList.length > 0">
              <a
                :href="`/scheduleDetail/${item.match_id}/1`"
                v-for="(item, index) of matchList"
                :key="index"
              >
                <dl class="time_name">
                  <dt class="time">
                    {{ dateFormat(item.match_time * 1000, "hh:mm") }}
                  </dt>
                  <dd class="date">
                    {{ dateFormat(item.match_time * 1000, "MM月dd日") }}
                  </dd>
                </dl>
                <dl class="time_name" style="width: 2.3rem">
                  <dt class="title">{{ item.venue_name }}</dt>
                  <dd>{{ item.venue_name_en }}</dd>
                </dl>
                <div :class="`match_group_${item.group_code}`">
                  {{ item.group_code }}组
                </div>
                <dl class="match_team_compare">
                  <dt>
                    <strong>{{ item.home_team_name }}</strong>
                    <span><img :src="item.home_team_logo" /></span>
                  </dt>
                  <dd>VS</dd>
                  <dt>
                    <span><img :src="item.away_team_logo" /></span>
                    <strong>{{ item.away_team_name }}</strong>
                  </dt>
                </dl>
                <span class="match_status" v-if="item.status_id == 2"
                  >未开始</span
                >
                <span class="match_status_starting" v-if="item.status_id == 1"
                  >进行中</span
                >
                <span class="match_status_end" v-if="item.status_id == 3"
                  >已结束</span
                >
                <span
                  class="match_status_end"
                  v-if="![1, 2, 3].includes(item.status_id)"
                  >异常</span
                >
              </a>
            </div>

            <!--无数据提示面板-->
            <dl
              class="panel_not_content"
              style="height: 5.8rem"
              v-if="matchList.length == 0"
            >
              <dt>
                <img src="./img/not_match.png" />
              </dt>
              <dd>暂无赛事</dd>
            </dl>
          </div>
        </div>

        <!--积分排行榜-->
        <div class="page_content" v-show="pagePanel === 2">
          <!--积分排行榜标题-->
          <ul class="panel_title">
            <li
              @click="getIntegralList('A')"
              :class="integralTag == 'A' ? 'active' : ''"
            >
              A组
            </li>
            <li
              @click="getIntegralList('B')"
              :class="integralTag == 'B' ? 'active' : ''"
            >
              B组
            </li>
            <li
              @click="getIntegralList('C')"
              :class="integralTag == 'C' ? 'active' : ''"
            >
              C组
            </li>
            <li
              @click="getIntegralList('D')"
              :class="integralTag == 'D' ? 'active' : ''"
            >
              D组
            </li>
            <li
              @click="getIntegralList('E')"
              :class="integralTag == 'E' ? 'active' : ''"
            >
              E组
            </li>
            <li
              @click="getIntegralList('F')"
              :class="integralTag == 'F' ? 'active' : ''"
            >
              F组
            </li>
            <li
              @click="getIntegralList('G')"
              :class="integralTag == 'G' ? 'active' : ''"
            >
              G组
            </li>
            <li
              @click="getIntegralList('H')"
              :class="integralTag == 'H' ? 'active' : ''"
            >
              H组
            </li>
          </ul>

          <!--积分排行榜的内容列表区-->
          <div class="integral_list">
            <!--页面内容块中的加载动画-->
            <div class="loading_mask" v-show="loading">
              <div class="loading_anim">
                <img src="../../assets/img/loading-2.gif" />
              </div>
            </div>
            <table v-if="groupIntegralls.length > 0">
              <tr>
                <th>排名</th>
                <th>球队</th>
                <th>场次</th>
                <th>胜平负</th>
                <th>进失球</th>
                <th>净胜球</th>
                <th>场均净失球</th>
                <th>场均净胜球</th>
                <th>积分</th>
              </tr>
              <tr v-for="(item, index) in groupIntegralls" :key="index">
                <td>
                  <span class="badge" v-if="index < 2">
                    <img :src="require(`./img/number${index + 1}.png`)" />
                  </span>
                  <span v-else>{{ index + 1 }}</span>
                </td>
                <td class="logo_name">
                  <span class="logo">
                    <img :src="item.team_logo" />
                  </span>
                  <span class="team_name">{{ item.team_name }}</span>
                </td>
                <td>{{ item.match_times }}</td>
                <td>{{ item.win }}/{{ item.draw }}/{{ item.lost }}</td>
                <td>{{ item.goals }}/{{ item.goals_conceded }}</td>
                <td>{{ item.goal_difference }}</td>
                <td>
                  {{
                    item.goals > 0
                      ? (item.goals / item.match_times).toFixed(2)
                      : 0
                  }}
                  /
                  {{
                    item.match_times > 0
                      ? (item.goals_conceded / item.match_times).toFixed(2)
                      : 0
                  }}
                </td>
                <td>
                  {{
                    item.match_times > 0
                      ? (item.goal_difference / item.match_times).toFixed(2)
                      : 0
                  }}
                </td>
                <td>{{ item.score }}</td>
              </tr>
            </table>
            <!--无数据提示面板-->
            <dl class="panel_not_content" v-show="groupIntegralls.length == 0">
              <dt>
                <img src="./img/not_match.png" />
              </dt>
              <dd>暂无积分排行数据</dd>
            </dl>
          </div>
        </div>

        <!--世界杯晋级图-->
        <div class="page_content" v-show="pagePanel === 3">
          <rise-map ref="riseMap"></rise-map>
        </div>

        <!--猜冠军，赢大奖-->
        <div
          class="page_content"
          v-show="pagePanel === 4 && guessPanelToggle == 1"
        >
          <div class="btn_open_guess_result" @click="openGuessResultWindow()">
            竞猜记录
          </div>
          <ul class="panel_title guess_prize">
            <li
              @click="setGuessTag('A')"
              :class="guessTag == 'A' ? 'active' : ''"
            >
              A组
            </li>
            <li
              @click="setGuessTag('B')"
              :class="guessTag == 'B' ? 'active' : ''"
            >
              B组
            </li>
            <li
              @click="setGuessTag('C')"
              :class="guessTag == 'C' ? 'active' : ''"
            >
              C组
            </li>
            <li
              @click="setGuessTag('D')"
              :class="guessTag == 'D' ? 'active' : ''"
            >
              D组
            </li>
            <li
              @click="setGuessTag('E')"
              :class="guessTag == 'E' ? 'active' : ''"
            >
              E组
            </li>
            <li
              @click="setGuessTag('F')"
              :class="guessTag == 'F' ? 'active' : ''"
            >
              F组
            </li>
            <li
              @click="setGuessTag('G')"
              :class="guessTag == 'G' ? 'active' : ''"
            >
              G组
            </li>
            <li
              @click="setGuessTag('H')"
              :class="guessTag == 'H' ? 'active' : ''"
            >
              H组
            </li>
          </ul>
          <div class="prize_team_list">
            <!--页面内容块中的加载动画-->
            <div class="loading_mask" v-show="loading">
              <div class="loading_anim">
                <img src="../../assets/img/loading-2.gif" />
              </div>
            </div>
            <ul v-if="currentGrouptotal > 0">
              <li
                v-for="(item, index) of guessTeams"
                :key="index"
                v-show="item.group_code == guessTag"
                :class="`${item.id == guessSelectedId ? 'active' : ''} ${
                  item.status != 1 ? 'bg_gray' : ''
                }`"
              >
                <span
                  v-if="item.status == 1"
                  @click="
                    openGuessWindow(item.team_name + '@' + item.odds, item.id)
                  "
                >
                  {{ item.team_name + "@" + item.odds.toFixed(2) }}
                </span>
                <span v-else>
                  {{ item.team_name + "@" + item.odds.toFixed(2) }}
                </span>
              </li>
            </ul>

            <!--无数据提示面板-->
            <dl class="panel_not_content" v-show="currentGrouptotal == 0">
              <dt>
                <img src="./img/not_match.png" />
              </dt>
              <dd>当前暂无可竞猜的信息</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <div
      class="guess_prize_remark"
      v-show="pagePanel === 4 && guessPanelToggle == 1"
    >
      <h3>平台提示：</h3>
      <p>1.以上赔率值均是包含本金部分。</p>
      <p>2.竞猜结果最迟会在决赛结束后结算。</p>
      <p>3.猎鹰直播平台对活动保留解释权。</p>
    </div>

    <!--竞猜赢大奖弹窗-->
    <div
      class="window_guess_prize_mask"
      v-show="guessWindow === true && guessPanelToggle == 1"
    >
      <div class="window_guess_prize">
        <span class="btn_close" @click="guessWindow = false">
          <img src="./img/icon_btn_close.png" />
        </span>
        <div class="title">
          <img src="./img/window_title_prize.png" />
        </div>
        <div class="team_name">{{ guessTeamName }}</div>
        <div class="write_area">
          <input
            type="text"
            name="setDiamond"
            @keyup="getCurrentInput($event)"
            v-model="currentDiamond"
            maxlength="10"
            placeholder="请输入竞猜克拉数"
          />
          <strong>克拉</strong>
        </div>
        <dl class="surplus_num">
          <dt>剩余克拉：</dt>
          <dd>{{ accountSurplusDiamond.toFixed(2) }}</dd>
        </dl>
        <ul class="money_list">
          <li
            v-for="(diamond, index) of guessDiamonds"
            :key="index"
            @click="setDiamondValue(diamond)"
            :class="
              setMaxDiamond === false && diamond == currentDiamond
                ? 'active'
                : ''
            "
          >
            {{ diamond }}
          </li>
          <li
            @click="setAllSurplus()"
            :class="setMaxDiamond === true ? 'active' : ''"
          >
            最大
          </li>
        </ul>
        <dl class="surplus_num">
          <dt>可赢克拉：</dt>
          <dd>{{ Number(canWinDiamond).toFixed(2) }}</dd>
        </dl>

        <ul class="btn_area">
          <li
            v-show="
              currentDiamond == 0 ||
              currentDiamond == '' ||
              isNaN(currentDiamond)
            "
          >
            确认
          </li>
          <li
            v-show="currentDiamond > 0"
            class="selected"
            @click="submitUserGuess()"
          >
            确认
          </li>
        </ul>
      </div>
    </div>

    <!--竞猜结果弹窗-->
    <div
      class="window_guess_prize_mask"
      v-show="guessResult === true && guessPanelToggle == 1"
    >
      <div
        class="window_guess_prize guess_prize_result"
        :style="`${
          (pager.records === null || pager.records.length == 0
            ? ''
            : 'height:' + (65 * pager.records.length + 250) / 100) + 'rem'
        }`"
      >
        <span class="btn_close" @click="guessResult = false">
          <img src="./img/icon_btn_close.png" />
        </span>
        <div class="title">
          <img src="./img/window_title_result.png" />
        </div>

        <div class="result_list" v-if="pager.total > 0">
          <table>
            <tr class="title_row">
              <th>竞猜单号</th>
              <th>竞猜时间</th>
              <th>球队名称</th>
              <th>竞猜克拉数</th>
              <th>竞猜状态</th>
            </tr>
            <tr v-for="(item, index) of pager.records" :key="index">
              <td>{{ item.order_id }}</td>
              <td>
                {{ dateFormat(item.created_at * 1000, "yyyy/MM/dd") }}
                <br />
                {{ dateFormat(item.created_at * 1000, "hh:mm:ss") }}
              </td>
              <td>{{ item.team_name }}@{{ item.current_odds.toFixed(2) }}</td>
              <td>{{ item.diamond / 100 }}克拉</td>
              <td>
                <span class="color_red" v-if="item.status == 1">待开奖</span>
                <span class="color_green" v-if="item.status == 2">赢</span>
                <span class="color_gray" v-if="item.status == 3">输</span>
              </td>
            </tr>
          </table>
        </div>

        <div class="world_cup_pager" v-show="pager.total > 0">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pager.pageSize"
            :total="pager.total"
            @current-change="getNextPager"
            :current-page="pager.page"
          >
          </el-pagination>
        </div>

        <!--无数据提示面板-->
        <dl class="panel_not_content" v-show="pager.total == 0">
          <dt>
            <img src="./img/not_match.png" />
          </dt>
          <dd>您当前还没有任何竞猜记录</dd>
        </dl>
      </div>
    </div>
    <Footer />

    <!--页面级的加载动画-->
    <div class="page_loading_mask" v-show="pageLoading">
      <div class="loading_anim">
        <img src="../../assets/img/loading-2.gif" />
      </div>
    </div>

    <!--自定义toast-->
    <div class="toast_message" v-show="showToast">{{ toastMessage }}</div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { post } from "@/util/http";
import { format } from "@/util/time";
import { CodeNode } from "source-list-map";

import Footer from "@/components/footer/footer";
import RiseMap from "@/components/world-cup/rise-map";

export default {
  name: "worldCup",
  // metaInfo() {
  //   return {
  //     title: "Xôi Lạc TV - Trực Tiếp Bóng Đá Hôm Nay | Xem Bóng Đá Miễn Phí",
  //     meta: [
  //       {
  //         name: "keywords",
  //         content:
  //           "xoilac, xoilac tv, xôi lạc trực tiếp bóng đá hôm nay, truc tiep bong da, xem bong da truc tuyen",
  //       },
  //     ],
  //   };
  // },
  components: { Footer, RiseMap },
  data() {
    return {
      //竞猜栏目开关
      guessPanelToggle: 0,
      //页面级的加载动画
      pageLoading: false,
      //页面上的内容块加载动画
      loading: false,
      //toast是否显示
      showToast: false,
      //toast中的消息内容
      toastMessage: "",
      //定义日期函数的处理方法
      dateFormat: format,
      //页面上不同的面板开关标识
      pagePanel: 1,
      //精彩体育赛事的标题切换开关
      matchGroupTag: "",
      //当前选中的星期几
      selectedWeekIndex: 0,
      //精彩体育赛事的周一至周日数据
      matchWeeks: [],
      //体育赛事列表内容
      matchList: [],
      //当前体育赛事列表一共有多少场比赛
      currentMatchTotal: 0,
      //星期列表的滚动位置
      weekScrollLeft: "0rem",
      //积分球队分组切换开关
      integralTag: "A",
      //积分球队分组数据
      groupIntegralls: [],
      //竞猜球队分组切换开关
      guessTag: "A",
      //竞猜球队清单
      guessTeams: [],
      //当前竞猜分组中是否有数据
      currentGrouptotal: 0,
      //当前竞猜用户选中的球队ID
      guessSelectedId: 0,
      //“猜冠军，赢大奖的弹窗”开关
      guessWindow: false,
      //“猜冠军，赢大奖的弹窗”的当前目标球队名称
      guessTeamName: "",
      //当前账户剩余克拉
      accountSurplusDiamond: 0.0,
      //当前选择的赛组赔率
      currentTeamOdds: 0.0,
      //当前投注可赢金额
      canWinDiamond: 0.0,
      //当前用户输入或选择的克拉
      currentDiamond: 0,
      //是否使用最大金额（账户剩余克拉）投注
      setMaxDiamond: false,
      //竞猜可选的金额清单
      guessDiamonds: [100, 500, 1000, 2000, 5000],
      //竞猜结果弹窗
      guessResult: false,
      //分页代码
      pager: {
        total: 0,
        pageSize: 5,
        page: 1,
        records: [],
      },
      //临时测试用的计数器
      tempCounter: 0,
    };
  },
  computed: {
    ...mapState(["userInfo", "appConfig"]),
  },
  methods: {
    ...mapMutations(["toggleLogin"]),
    ...mapActions(["getUserInfo"]),
    /**
     * Toast效果
     * @param string message 提示消息内容
     * @param int second 消息显示的秒数，默认不提供为1.5秒
     * @param boolean status 状态：true为显示，false为隐藏，默认显示
     */
    setShowToast(message) {
      this.toastMessage = message;
      let second = arguments[1] ? arguments[1] : 1.5;
      this.showToast = arguments[2] ? arguments[2] : true;
      if (this.showToast === true) {
        setTimeout(() => {
          this.showToast = false;
        }, second * 1000);
      }
    },
    /**
     * 重置地址栏参数，防止刷新后失去当前定位的选项
     */
    resetUrl() {
      const origin = window.location.origin;
      const path = window.location.pathname;
      const url = `${origin}${path}?panelId=${this.pagePanel}&mgTag=${this.matchGroupTag}&weekKey=${this.selectedWeekIndex}&gueTag=${this.guessTag}&inTag=${this.integralTag}`;

      window.history.pushState("", "", url);
      //将URL返回给需要强行跳转的地方调用
      return url;
    },

    /**
     * 滚动浏览器到面板标题的位置
     */
    scrollShowPageTitle() {
      let start_top = document.documentElement.scrollTop;
      //目标位置
      let scroll_to_top = 500;
      //多长时间滚动完毕
      let scroll_speed = scroll_to_top / 50;
      var scroll_timer = setInterval(function () {
        if (start_top > scroll_to_top) {
          start_top -= scroll_speed;
          document.documentElement.scrollTop = start_top;
          if (start_top <= scroll_to_top) {
            clearInterval(scroll_timer);
          }
        } else {
          start_top += scroll_speed;
          document.documentElement.scrollTop = start_top;
          if (start_top >= scroll_to_top) {
            clearInterval(scroll_timer);
          }
        }
      }, 10);
    },

    /**
     * 切换页面上的面板显示与隐藏
     * @param int panel_tag 不同面板的标识符
     */
    changePanel(panel_tag) {
      this.pagePanel = panel_tag;
      this.resetUrl();
      this.initPageLoaded();
      this.$nextTick(function () {
        this.scrollShowPageTitle();
      });
    },

    /**
     * 设置体育赛事标题选中项
     * @param {string} tag 选中项标识符
     */
    setMatchGroupTag(tag) {
      this.matchGroupTag = tag;
      this.getMatchList();
    },

    /**
     * 选择某个星期
     * @param int index 切换成周几的下标
     */
    setChangeWeek(index) {
      this.selectedWeekIndex = index;
      this.getMatchList();
    },

    /**
     * 获取体育赛事列表内容
     */
    getMatchList() {
      //初始化当有选中的天的比赛场次总数，防止调用前一条请求的缓存数据，会出现总数不对应的情况
      this.currentMatchTotal = 0;
      //重置地址栏请求参数
      this.resetUrl();
      //获取赛事列表内容
      this.loading = true;
      //取赛事列表
      const post_params = {
        group_code: this.matchGroupTag,
        match_date: this.matchWeeks[this.selectedWeekIndex].date,
      };
      post({
        url: "/api/sport/world_cup_group_match",
        data: post_params,
      })
        .then((res) => {
          if (res.status === 200 && res.data.status === 0) {
            let new_data = res.data.data.world_cup_group_match;
            if (new_data == null) {
              this.matchList = [];
            } else {
              this.matchList = new_data;
            }
            this.currentMatchTotal = this.matchList.length;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 获取积分排行榜内容列表
     * @param string team_tag 当前球队分组标识
     */
    getIntegralList(team_tag) {
      //切换标题
      this.integralTag = team_tag;
      //重置地址栏请求参数
      this.resetUrl();
      //获取积分排行榜数据
      this.loading = true;
      const post_params = {
        group_code: this.integralTag,
      };
      post({
        url: "/api/sport/world_cup_team_point",
        data: post_params,
      })
        .then((res) => {
          this.loading = false;
          if (res.status === 200 && res.data.status === 0) {
            let new_data = res.data.data.world_cup_team_point;
            if (new_data == null) {
              this.groupIntegralls = [];
            } else {
              this.groupIntegralls = new_data;
            }
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 切换球队分组
     * @param {string} team_tag 球队分组名称
     */
    setGuessTag(team_tag) {
      //切换标题
      this.guessTag = team_tag;
      //重置地址栏请求参数
      this.resetUrl();
      //计算当前分组中是否有数据
      let group_total = 0;
      this.guessTeams.forEach((item) => {
        if (item.group_code == this.guessTag) {
          group_total++;
        }
      });
      this.currentGrouptotal = group_total;
    },

    /**
     * 获取竞猜球队列表
     * @param string team_tag 当前球队分组标识
     */
    getGuessTeams(team_tag) {
      //切换标题
      this.guessTag = team_tag;
      //重置地址栏请求参数
      this.resetUrl();
      //获取赛事列表内容
      this.loading = true;
      //移动端是一次性取完所有分组的数据，因为移动端没有分组。
      //所以和接口方沟通了，PC端取回来后自己手动分组。
      post({
        url: "/api/sport/world_cup_game_team",
      })
        .then((res) => {
          if (res.status === 200 && res.data.status === 0) {
            let new_data = res.data.data.world_cup_game;
            if (typeof new_data == "object") {
              //计算当前分组中是否有数据
              let group_total = 0;
              new_data.forEach((item) => {
                if (item.group_code == this.guessTag) {
                  group_total++;
                }
              });
              this.currentGrouptotal = group_total;
              //重新赋值
              this.guessTeams = new_data;
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 打开“猜冠军，赢大奖的弹窗”
     * @param {string} title 当前选中者的标题名
     * @param {int} id 当前选中者的主键ID
     */
    openGuessWindow(title, id) {
      //检测用户是否在线
      if (!this.userInfo.id) {
        this.toggleLogin();
        return false;
      }
      //更新用户数据
      this.getUserInfo();
      this.setMaxDiamond = false;
      //重置默认下注克拉为0
      this.currentDiamond = 0;
      this.guessSelectedId = id;
      //当前倍率
      let name_arr = title.split("@");
      this.currentTeamOdds = Number(name_arr[1] > 0 ? name_arr[1] : 0).toFixed(
        2
      );
      this.guessTeamName = name_arr[0] + "@" + this.currentTeamOdds;
      //当前剩余克拉数
      this.accountSurplusDiamond = this.userInfo.diamond / 100;
      this.canWinDiamond = (
        this.accountSurplusDiamond * this.currentTeamOdds
      ).toFixed(2);
      //打开弹窗
      this.guessWindow = true;
    },

    /**
     * 获取当前用户输入的金额
     * @param Object event 当前事件对象
     */
    getCurrentInput(event) {
      //取消最大金额按钮的选中状态
      this.setMaxDiamond = false;
      let val = event.currentTarget.value;
      //如果含有小数点，就把小数点删除
      val = val.replace(/[\.| ]+/g, "");
      this.currentDiamond = parseInt(val);
      console.log("this.currentDiamond:", this.currentDiamond);
      if (isNaN(this.currentDiamond) || this.currentDiamond < 1) {
        this.currentDiamond = "";
      }
      //投注可赢克拉
      this.canWinDiamond = (this.currentTeamOdds * this.currentDiamond).toFixed(
        2
      );
    },
    /**
     * 获取当前用户选择的金额
     * @param int diamond 克拉数量
     */
    setDiamondValue(diamond) {
      //取消最大金额按钮的选中状态
      this.setMaxDiamond = false;
      this.currentDiamond = parseFloat(diamond);
      if (isNaN(this.currentDiamond)) {
        this.currentDiamond = 0;
      }
      //投注可赢克拉
      this.canWinDiamond = this.currentTeamOdds * this.currentDiamond;
    },
    /**
     * 使用最大金额（账户剩余金额）进行投注
     */
    setAllSurplus() {
      this.setMaxDiamond = true;
      //重置默认下注克拉为0
      this.currentDiamond = 0;
      //当前投注克拉
      this.currentDiamond = Math.floor(this.accountSurplusDiamond);
      //投注可赢克拉
      this.canWinDiamond = (this.currentTeamOdds * this.currentDiamond).toFixed(
        2
      );
    },

    /**
     * 提交用户的竞猜请求
     */
    submitUserGuess() {
      if (this.currentDiamond < 1) {
        this.setShowToast("竞猜克拉数必须大于1");
        return false;
      }
      if (this.currentDiamond > this.accountSurplusDiamond) {
        this.setShowToast("竞猜额超出克拉余额");
        return false;
      }
      //提交用户的选择
      this.pageLoading = true;
      let post_params = {
        diamond: this.currentDiamond,
        id: this.guessSelectedId,
        odds: Number(this.currentTeamOdds).toFixed(2),
        user_id: this.userInfo.id,
      };
      post({
        url: "/api/sport/world_cup_game_order",
        data: post_params,
      })
        .then((res) => {
          this.pageLoading = false;
          if (res.status === 200 && res.data.status === 0) {
            //更新用户数据
            this.getUserInfo();
            if (res.data.msg == "SUCCESS") {
              this.setShowToast("参与竞猜成功~");
              //关闭弹窗
              this.guessWindow = false;
            } else {
              this.setShowToast(res.data.msg);
            }
          } else {
            this.setShowToast("竞猜请求失败，请重试~");
          }
        })
        .catch(() => {
          //更新用户数据
          this.getUserInfo();
          this.pageLoading = false;
        });
    },

    /**
     * 获取一周内的比赛数据
     * @param string tag 取数据的标识：prev:取当前周的前一周，next:取当前周的后一周
     */
    getMatchWeeks(tag) {
      let current_left = parseFloat(this.weekScrollLeft.replace("rem", ""));
      //向前取一周的数据
      if (tag == "prev") {
        current_left = current_left + 13.16;
        if (current_left > 0) {
          this.weekScrollLeft = "0rem";
        } else {
          this.weekScrollLeft = current_left + "rem";
        }
      }
      //向后取一周的数据
      if (tag == "next") {
        current_left = current_left - 13.16;
        if (current_left < -40) {
          this.weekScrollLeft = "-39.48rem";
        } else {
          this.weekScrollLeft = current_left + "rem";
        }
      }
    },

    /**
     * 初始化比赛的周期数据
     */
    initMatchWeeks() {
      //构造星期及日期数据
      let weeks = ["一", "二", "三", "四", "五", "六", "日"];
      let week_key = 0;
      //十一月
      for (let m = 21; m <= 30; m++) {
        let day = {
          week: "星期" + weeks[week_key],
          date: "2022-11-" + m,
          monthDay: "11-" + m,
        };
        week_key++;
        if (week_key > 6) {
          week_key = 0;
        }
        this.matchWeeks.push(day);
      }
      //十二月
      week_key = 3;
      for (let m = 1; m <= 18; m++) {
        //将m的值处理成双日期格式
        let day_num = m;
        if (day_num < 10) {
          day_num = "0" + m;
        }
        let day = {
          week: "星期" + weeks[week_key],
          date: "2022-12-" + day_num,
          monthDay: "12-" + day_num,
        };
        week_key++;
        if (week_key > 6) {
          week_key = 0;
        }
        this.matchWeeks.push(day);
      }
    },

    /**
     * 获取我的竞猜结果
     */
    getMyGuessRecords() {
      if (this.guessPanelToggle === 0) {
        this.showToast("当前栏目已关闭，暂不能执行该操作~");
        return false;
      }
      this.pageLoading = true;
      let post_params = {
        page: this.pager.page,
        size: this.pager.pageSize,
        user_id: this.userInfo.id,
      };
      post({
        url: "/api/sport/world_cup_game_order_list",
        data: post_params,
      })
        .then((res) => {
          this.pageLoading = false;
          if (res.status === 200 && res.data.status === 0) {
            //总条数
            this.pager.total = res.data.data.total;
            //记录
            this.pager.records = res.data.data.list;
          } else {
            this.setShowToast("获取竞猜记录失败~");
          }
        })
        .catch(() => {
          this.pageLoading = false;
        });
    },

    /**
     * 打开“竞猜结果的弹窗”
     */
    openGuessResultWindow() {
      if (this.guessPanelToggle === 0) {
        this.showToast("当前栏目已关闭，暂不能执行该操作~");
        return false;
      }
      this.guessResult = true;
      this.getMyGuessRecords();
    },

    /**
     * 分页取竞猜记录
     */
    getNextPager(page) {
      if (this.guessPanelToggle === 0) {
        this.showToast("当前栏目已关闭，暂不能执行该操作~");
        return false;
      }
      this.pager.page = page;
      this.getMyGuessRecords();
    },

    /**
     * 页面数据初始化
     */
    initPageLoaded() {
      //如果定位是第一个面板，则执行赛事列表请求
      if (this.pagePanel == 1) {
        this.initMatchWeeks();
        this.getMatchList(this.matchGroupTag);
      }
      //如果是第二个面板，则执行积分列表请求
      if (this.pagePanel == 2) {
        this.getIntegralList(this.integralTag);
      }
      //如果是第三个面板，则执行晋级图请求
      if (this.pagePanel == 3) {
        this.$nextTick(function () {
          this.$refs.riseMap.getRiseMap();
        });
      }
      //如果是第四个面板，则执行竞猜请求
      if (this.pagePanel == 4) {
        this.getGuessTeams(this.guessTag);
      }
    },

    /**
     * 检查缓存地址中的接口值是否返回。如果返回了就停止检查
     * 启用一个定时器来检查
     */
    checkOpenConfigs() {
      let timer_guess = setInterval(() => {
        if (
          this.appConfig.worldcup_thematic_toggle !== undefined &&
          this.appConfig.worldcup_guess_toggle !== undefined
        ) {
          clearInterval(timer_guess);
        }
        if (this.appConfig.worldcup_thematic_toggle !== undefined) {
          //如果世界杯专题已关闭，则直接跳转到首页
          if (Number(this.appConfig.worldcup_thematic_toggle) === 0) {
            window.location.href = "/home";
            return false;
          }
        }
        if (this.appConfig.worldcup_guess_toggle !== undefined) {
          this.guessPanelToggle = Number(this.appConfig.worldcup_guess_toggle);
          //如果面板关闭了且用户当前正想访问第4个面板，则强行跳转到第一个赛事面板
          if (this.pagePanel == 4 && this.guessPanelToggle === 0) {
            this.pagePanel = 1;
            this.matchGroupTag = "";
            this.initMatchWeeks();
            this.getMatchList(this.matchGroupTag);
            //重置一次URL
            this.resetUrl();
          }
        }
      }, 500);
    },
  },
  mounted() {
    //获取地址栏参数，并重置data中的部分参数值
    const getParmas = this.$route.query;
    //页面上不同的面板开关标识
    if (getParmas.panelId) {
      this.pagePanel = parseInt(getParmas.panelId);
    }
    //精彩体育赛事的标题切换开关
    if (getParmas.mgTag) {
      this.matchGroupTag = getParmas.mgTag;
    }
    //当前选中的星期几
    if (getParmas.weekKey) {
      this.selectedWeekIndex = parseInt(getParmas.weekKey);
    }
    //积分球队分组切换开关
    if (getParmas.inTag) {
      this.integralTag = getParmas.inTag;
    }
    //竞猜球队分组切换开关
    if (getParmas.gueTag) {
      this.guessTag = getParmas.gueTag;
    }
    this.initPageLoaded();
    //识别栏目和竞猜的初始化的状态
    this.checkOpenConfigs();
  },
};
</script>

<style lang="scss">
.world_cup_page {
  clear: both;
  width: 100%;
  min-width: 14rem;
  background: url(./img/body_bg.png) no-repeat top center;
  background-size: 100%;
  background-color: #81102f;
  padding-top: 0.66rem;

  //分页代码样式
  ::v-deep {
    .world_cup_pager {
      display: flex;
      justify-content: center;
      clear: both;
      width: 100%;
      height: 0.5rem;
      overflow: hidden;

      .el-pager li:hover {
        color: #a8032b;
      }

      .el-pager li.active,
      .el-pager li.active:hover {
        background-color: #a8032b;
        color: #fff;
      }
    }
  }

  //toast效果
  .toast_message {
    display: block;
    clear: both;
    width: auto;
    min-width: 2rem;
    height: 0.4rem;
    line-height: 0.2rem;
    overflow: hidden;
    background-color: #000;
    box-sizing: border-box;
    padding: 0.1rem;
    border-radius: 8px;
    font-size: 0.16rem;
    text-align: center;
    color: #fff;
    position: fixed;
    z-index: 100000;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
  }

  //暂无赛事的提示面板
  .panel_not_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    clear: both;
    width: 100%;
    height: 3rem;
    overflow: hidden;

    dt {
      display: flex;
      justify-content: center;
      align-items: center;
      clear: both;
      width: 2.2rem;
      height: 2.2rem;
      overflow: hidden;

      img {
        display: block;
        width: 100%;
      }
    }

    dd {
      clear: both;
      width: 100%;
      height: 0.5rem;
      line-height: 0.5rem;
      overflow: hidden;
      font-size: 0.18rem;
      color: #999;
      text-align: center;
    }
  }

  //页面左侧飘浮条
  .page_float_window {
    display: block;
    float: left;
    width: 0.98rem;
    height: auto;
    overflow: hidden;
    background-color: rgba(255, 255, 255, 0.35);
    box-sizing: border-box;
    padding: 0.04rem;
    border-radius: 0.5rem;
    position: absolute;
    z-index: 50;
    left: 0.2rem;
    top: 3rem;

    ul {
      clear: both;
      width: 100%;
      height: 100%;
      overflow: hidden;
      background-color: #fff;
      box-sizing: border-box;
      border-radius: 0.5rem;
      padding: 0.24rem 0.1rem;

      li {
        clear: both;
        width: 100%;
        height: 0.78rem;
        overflow: hidden;
        box-sizing: border-box;
        margin-bottom: 0.2rem;
        cursor: pointer;
        position: relative;

        &:last-child {
          margin-bottom: 0;
        }

        span {
          display: block;
          clear: both;
          width: 0.36rem;
          height: 0.36rem;
          overflow: hidden;
          margin: 0 auto;

          img {
            display: block;
            width: 100%;
          }
        }

        strong {
          display: block;
          width: 100%;
          height: 0.2rem;
          line-height: 0.2rem;
          overflow: hidden;
          margin-top: 8px;
          font-size: 0.18rem;
          color: #999;
          text-align: center;
          font-weight: 400;
        }

        &:hover {
          strong {
            color: #a8032b;
          }
        }
      }

      li.active {
        &::after {
          content: "";
          display: block;
          clear: both;
          width: 0;
          height: 0;
          overflow: hidden;
          border: 0.08rem solid transparent;
          border-bottom-color: #a8032b;
          margin: 0 auto;
          position: absolute;
          z-index: 2;
          left: 0;
          right: 0;
          bottom: 0;
        }

        strong {
          font-weight: bold;
          color: #a8032b;
        }
      }
    }
  }

  //竞猜赢大奖弹窗
  .window_guess_prize_mask {
    clear: both;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;

    .window_guess_prize {
      clear: both;
      width: 4.9rem;
      height: 4.6rem;
      overflow: hidden;
      background: linear-gradient(158.56deg, #ffeaf1 0%, #ffffff 42.59%);
      background-color: #fff;
      box-shadow: 0px 0px 0.24rem rgba(60, 0, 25, 0.3);
      -webkit-box-shadow: 0px 0px 0.24rem rgba(60, 0, 25, 0.3);
      -moz-box-shadow: 0px 0px 0.24rem rgba(60, 0, 25, 0.3);
      -o-box-shadow: 0px 0px 0.24rem rgba(60, 0, 25, 0.3);
      -ms-box-shadow: 0px 0px 0.24rem rgba(60, 0, 25, 0.3);
      border-radius: 0.2rem;
      box-sizing: border-box;
      padding: 0.36rem;
      margin: auto auto;
      position: absolute;
      z-index: 10;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;

      .btn_close {
        display: block;
        float: right;
        width: 0.16rem;
        height: 0.16rem;
        overflow: hidden;
        position: absolute;
        z-index: 5;
        right: 0.2rem;
        top: 0.2rem;
        cursor: pointer;

        img {
          display: block;
          width: 100%;
        }
      }

      .title {
        clear: both;
        width: 100%;
        height: 0.4rem;
        overflow: hidden;
        margin-bottom: 0.15rem;

        img {
          display: block;
          height: 100%;
          margin: 0 auto;
        }
      }

      .team_name {
        clear: both;
        width: 100%;
        height: 0.5rem;
        overflow: hidden;
        font-size: 0.24rem;
        color: #333;
        text-align: center;
      }

      .write_area {
        clear: both;
        width: 100%;
        height: 0.4rem;
        overflow: hidden;
        border-radius: 0.05rem;
        background-color: #f0f0f0;
        box-sizing: border-box;
        padding: 0px 0.1rem;
        padding-right: 0.6rem;
        position: relative;

        input {
          display: block;
          clear: both;
          width: 100%;
          height: 100%;
          line-height: 0.4rem;
          overflow: hidden;
          font-size: 0.18rem;
          color: #333;
          outline: none;

          &::placeholder {
            font-size: 0.14rem;
            color: #999999;
          }
        }

        strong {
          display: block;
          float: right;
          width: 0.6rem;
          height: 100%;
          line-height: 0.4rem;
          overflow: hidden;
          font-family: "PingFang SC";
          font-size: 0.18rem;
          font-weight: 500;
          color: #333;
          text-align: center;
          position: absolute;
          z-index: 5;
          right: 0;
          top: 0;
        }
      }

      .surplus_num {
        clear: both;
        width: 100%;
        height: 0.3rem;
        line-height: 0.3rem;
        overflow: hidden;
        font-size: 0.14rem;

        dt,
        dd {
          float: left;
          width: auto;
          height: 100%;
          overflow: hidden;
          color: #999;
        }

        dd {
          color: #a8032b;
          font-weight: 500;
        }
      }

      .money_list {
        clear: both;
        width: 100%;
        height: 1rem;
        overflow: hidden;
        box-sizing: border-box;
        padding-top: 0.1rem;

        li {
          float: left;
          width: 0.72rem;
          height: 0.4rem;
          line-height: 0.38rem;
          overflow: hidden;
          border: 1px solid #dbdbdb;
          border-radius: 0.05rem;
          font-size: 0.18rem;
          color: #333;
          text-align: center;
          margin-right: 0.1rem;
          margin-bottom: 0.1rem;
          cursor: pointer;
          user-select: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -o-user-select: none;
          -ms-user-select: none;

          &:hover,
          &.active {
            border-color: #a8032b;
            color: #a8032b;
          }

          &.active {
            background: url("./img/icon_rect_selected.png") no-repeat bottom
              right;
            background-size: 0.25rem;
          }
        }
      }

      .btn_area {
        clear: both;
        width: 100%;
        overflow: hidden;
        padding: 0.1rem;
        padding-top: 0.2rem;

        li {
          clear: both;
          width: 3.2rem;
          height: 0.48rem;
          line-height: 0.48rem;
          overflow: hidden;
          background: linear-gradient(108.02deg, #e2e4e4 0%, #d3d6da 62.15%);
          box-sizing: border-box;
          border-radius: 0.06rem;
          margin: 0 auto;
          font-size: 0.16rem;
          font-weight: bold;
          color: #fff;
          text-align: center;
          cursor: default;
          user-select: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -o-user-select: none;
          -ms-user-select: none;
        }

        li.selected {
          background: linear-gradient(90deg, #be023d 0%, #421124 100%);
          box-shadow: 0px 4px 8px rgba(48, 185, 188, 0.2);
          cursor: pointer;
        }
      }
    }

    //竞猜结果弹窗
    .guess_prize_result {
      width: 10rem;

      .title {
        height: 0.35rem;
      }

      .result_list {
        clear: both;
        width: 100%;
        height: calc(100% - 0.75rem);
        overflow: hidden;
        overflow-y: auto;
        padding-bottom: 0.2rem;

        table {
          width: 100%;

          tr.title_row {
            background: linear-gradient(180deg, #bb2052 0%, #8d0e37 100%);
          }

          th,
          td {
            width: 20%;
            height: 0.44rem;
            font-size: 16px;
            font-weight: 400;
            color: #fff;
            text-align: center;
          }

          td {
            height: 0.72rem;
            background-color: #fff;
            color: #333;
            border-left: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            padding: 0px 3px;

            &:last-child {
              border-right: 1px solid #f0f0f0;
            }

            .color_green {
              color: #33cc00;
            }

            .color_gray {
              color: #999;
            }

            .color_red {
              color: #f64d5c;
            }
          }
        }
      }
    }
  }

  .word_cup_header_banner {
    clear: both;
    width: 100%;
    min-width: 14rem;
    overflow: hidden;

    img {
      display: block;
      width: 100%;
    }
  }

  .page_item_title {
    clear: both;
    width: 14.4rem;
    height: 0.8rem;
    margin: 0.8rem auto;
    margin-bottom: 0.5rem;
    overflow: hidden;

    img {
      display: block;
      height: 100%;
      margin: 0 auto;
    }
  }

  .loading_mask,
  .page_loading_mask {
    clear: both;
    width: 100%;
    height: 100%;
    min-height: 3rem;
    overflow: hidden;
    background-color: rgba(255, 255, 255, 0.8);
    position: absolute;
    z-index: 100;
    left: 0;
    top: 0;

    .loading_anim {
      clear: both;
      width: 1.5rem;
      height: 1.5rem;
      overflow: hidden;
      margin: auto auto;
      position: absolute;
      z-index: 5;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;

      img {
        display: block;
        width: 100%;
      }
    }
  }

  .page_loading_mask {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 10000;

    .loading_anim {
      position: fixed;
    }
  }

  .page_body {
    clear: both;
    width: 14.4rem;
    height: auto;
    background-color: rgba($color: #ffffff, $alpha: 0.2);
    box-shadow: 0px 0px 24px rgba(112, 0, 47, 0.3);
    box-sizing: border-box;
    border-radius: 0.2rem;
    padding: 0.2rem;
    margin: 0.2rem auto;
    margin-bottom: 0.5rem;

    .page_content {
      clear: both;
      width: 100%;
      height: auto;
      position: relative;
    }

    .page_panel {
      clear: both;
      width: 100%;
      height: auto;
      background-color: #fafafa;
      box-sizing: border-box;
      border-radius: 0.1rem 0.1rem 0.2rem 0.2rem;

      .panel_title {
        clear: both;
        width: 100%;
        height: 0.9rem;
        overflow: hidden;
        background: linear-gradient(180deg, #bb2052 0%, #8d0e37 100%);
        box-sizing: border-box;
        padding: 0.24rem;
        border-top-left-radius: 0.1rem;
        border-top-right-radius: 0.1rem;

        li {
          display: flex;
          justify-content: center;
          align-items: center;
          float: left;
          width: 0.72rem;
          height: 100%;
          overflow: hidden;
          border-radius: 0.09rem;
          font-size: 0.18rem;
          color: #fff;
          text-align: center;
          cursor: pointer;
          margin-right: 0.2rem;

          &:hover {
            background-color: #fff;
            color: #a8032b;
          }
        }

        li.active {
          background-color: #fff;
          color: #a8032b;
        }
      }

      //竞猜记录
      .btn_open_guess_result {
        float: right;
        width: 1.1rem;
        height: 0.32rem;
        line-height: 0.3rem;
        overflow: hidden;
        background: linear-gradient(180deg, #bb2052 0%, #8d0e37 100%);
        border: 0.5px solid rgba(255, 225, 159, 0.5);
        border-radius: 0.05rem;
        font-size: 0.18rem;
        color: #ffe19f;
        text-align: center;
        position: absolute;
        z-index: 10;
        right: 0;
        top: -0.8rem;
        cursor: pointer;
      }

      .guess_prize {
        display: flex;
        justify-content: space-between;

        li {
          width: 100%;
        }
      }

      //星期切换
      .change_week_row {
        clear: both;
        width: 100%;
        height: 0.7rem;
        overflow: hidden;
        background-color: #fff;
        box-sizing: border-box;
        padding: 0px 0.42rem;
        position: relative;

        dt {
          display: flex;
          justify-content: center;
          align-items: center;
          float: left;
          width: 0.42rem;
          height: 100%;
          overflow: hidden;
          position: absolute;
          z-index: 2;
          left: 0;
          top: 0;
          cursor: pointer;

          &:last-child {
            float: right;
            left: auto;
            right: 0;
          }

          img {
            display: block;
            width: 0.12rem;
          }
        }

        dd {
          float: left;
          width: 100%;
          height: 100%;
          overflow: hidden;

          .week_days {
            clear: both;
            width: 66rem;
            height: 100%;
            overflow: hidden;
            position: relative;
            z-index: 1;
            left: 0;
            top: 0;

            li {
              display: flex;
              flex-direction: column;
              justify-content: center;
              float: left;
              width: 1.88rem;
              height: 100%;
              overflow: hidden;
              box-sizing: border-box;
              border-bottom: 1px solid transparent;
              cursor: pointer;

              h3,
              p {
                clear: both;
                width: 100%;
                height: 0.24rem;
                line-height: 0.24rem;
                overflow: hidden;
                font-size: 0.16rem;
                color: #333;
                text-align: center;
                font-weight: 400;
              }

              p {
                color: #666;
              }

              &.active {
                border-bottom: 1px solid #a8032b;

                h3,
                p {
                  color: #a8032b;
                }
              }

              &:hover {
                h3,
                p {
                  color: #a8032b;
                }
              }
            }
          }
        }
      }

      //内容面板外框，主要用于包裹内容后做其它相关操作
      .panel_content {
        clear: both;
        width: 100%;
        height: auto;
        min-height: 4rem;
        position: relative;
      }

      //精彩体育赛事列表
      .panel_match_list {
        clear: both;
        width: 100%;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0.16rem 0.24rem;

        a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          clear: both;
          width: 100%;
          height: 0.96rem;
          overflow: hidden;
          background-color: #fff;
          box-sizing: border-box;
          padding: 0.25rem 0.5rem;
          margin-bottom: 0.12rem;

          &:hover {
            background-image: linear-gradient(90deg, #ffdbe4 0%, #ffffff 100%);
          }

          .time_name {
            float: left;
            width: 1.1rem;
            height: 100%;
            overflow: hidden;

            dt,
            dd {
              clear: both;
              width: 100%;
              height: 0.24rem;
              line-height: 0.24rem;
              overflow: hidden;
              font-family: "PingFang SC";
              font-size: 0.2rem;
              color: #333;
            }

            dt.time {
              font-size: 0.18rem;
              font-weight: bold;
            }

            dt.title {
              font-weight: 500;
            }

            dd {
              font-weight: 400;
              font-size: 0.12rem;
              color: #666;
            }
          }

          .match_group_A,
          .match_group_B,
          .match_group_C,
          .match_group_D,
          .match_group_E,
          .match_group_F,
          .match_group_G,
          .match_group_H {
            flex-shrink: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            float: left;
            width: 0.58rem;
            height: 0.3rem;
            overflow: hidden;
            border-radius: 0.05rem;
            font-size: 0.16rem;
          }

          .match_group_A {
            background-color: rgba(255, 113, 147, 0.15);
            color: #a8032b;
          }

          .match_group_B {
            background-color: rgba(2, 168, 162, 0.15);
            color: #00a2a9;
          }

          .match_group_C {
            background-color: rgba(28, 173, 255, 0.15);
            color: #1389cb;
          }

          .match_group_D {
            background-color: rgba(255, 0, 0, 0.15);
            color: #ff0000;
          }

          .match_group_E {
            background-color: rgba(219, 0, 255, 0.15);
            color: #8f00c3;
          }

          .match_group_F {
            background-color: #f7e5c4;
            color: #ed7200;
          }

          .match_group_G {
            background-color: #dae2ff;
            color: #0018ed;
          }

          .match_group_H {
            background-color: #f5ffda;
            color: #44a834;
          }

          .match_team_compare {
            flex-shrink: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 7.4rem;
            height: 0.4rem;
            overflow: hidden;
            padding: 0px 0.1rem;
            padding-right: 1.5rem;
            font-family: "PingFang SC";

            dd {
              flex-shrink: 0;
              width: 1rem;
              height: 100%;
              line-height: 0.4rem;
              overflow: hidden;
              font-size: 0.24rem;
              font-weight: 500;
              text-align: center;
            }

            dt {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              height: 100%;
              overflow: hidden;

              strong {
                display: block;
                float: left;
                width: 100%;
                height: 100%;
                line-height: 0.4rem;
                overflow: hidden;
                box-sizing: border-box;
                padding: 0px 0.15rem;
                font-size: 0.18rem;
                font-weight: 500;
                color: #333;
                text-align: right;

                &:last-child {
                  text-align: left;
                }
              }

              span {
                flex-shrink: 0;
                width: 0.4rem;
                height: 0.4rem;
                overflow: hidden;
                border-radius: 0.4rem;

                img {
                  display: block;
                  height: 100%;
                  margin: 0 auto;
                }
              }
            }
          }

          .match_status,
          .match_status_starting,
          .match_status_end {
            flex-shrink: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 0.92rem;
            height: 0.32rem;
            overflow: hidden;
            background-color: rgba(168, 3, 43, 0.1);
            box-sizing: border-box;
            border: 1px solid #a8032b;
            border-radius: 0.3rem;
            font-size: 0.18rem;
            color: #a8032b;
          }

          .match_status_starting {
            background: linear-gradient(90deg, #be023d 0%, #421124 100%);
            border: none;
            color: #fff;
          }

          .match_status_end {
            background-color: #f0f0f0;
            border-color: rgba(153, 153, 153, 0.3);
            color: #999;
          }
        }
      }

      //积分排行榜的内容列表区
      .integral_list {
        clear: both;
        width: 100%;
        height: auto;
        min-height: 3rem;
        overflow: hidden;
        background-color: #fff;
        padding-bottom: 0.25rem;
        border-bottom-left-radius: 0.2rem;
        border-bottom-right-radius: 0.2rem;
        position: relative;

        table {
          width: 100%;

          tr:hover {
            background: linear-gradient(90deg, #ffdbe4 0%, #ffffff 100%);
          }

          th {
            height: 0.7rem;
            background-color: #fff;
            padding: 0px 0.5rem;
            font-size: 0.16rem;
            font-weight: 400;
            color: #333;
          }

          td {
            height: 0.7rem;
            padding: 0px 0.5rem;
            font-size: 0.18rem;
            color: #000;
            text-align: center;

            .badge,
            .logo {
              display: inline-block;
              width: 0.28rem;
              height: 0.28rem;
              overflow: hidden;
              vertical-align: middle;
              border-radius: 0.3rem;

              img {
                display: block;
                height: 100%;
                margin: 0 auto;
              }
            }

            .team_name {
              display: inline-block;
              width: auto;
              height: 0.28rem;
              line-height: 0.28rem;
              padding-left: 0.1rem;
            }
          }

          td.logo_name {
            text-align: left;
          }
        }
      }

      //猜冠军，赢大奖列表
      .prize_team_list {
        clear: both;
        width: 100%;
        min-width: 14rem;
        height: auto;
        min-height: 4rem;
        overflow: hidden;
        background-color: #fff;
        border-bottom-left-radius: 0.15rem;
        border-bottom-right-radius: 0.15rem;
        padding-bottom: 0.3rem;
        position: relative;

        ul {
          clear: both;
          width: 100%;
          overflow: hidden;
          box-sizing: content-box;
          border-left: 1px solid #ffd3d3;
          border-top: 1px solid #ffd3d3;

          li {
            float: left;
            width: 1.75rem;
            height: 0.7rem;
            line-height: 0.7rem;
            overflow: hidden;
            box-sizing: border-box;
            border-right: 1px solid #ffd3d3;
            border-bottom: 1px solid #ffd3d3;
            font-size: 0.18rem;
            color: #333;
            text-align: center;
            cursor: pointer;
            user-select: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -o-user-select: none;
            -ms-user-select: none;
            position: relative;

            span {
              display: block;
              clear: both;
              width: 100%;
              height: 100%;
              overflow: hidden;
            }

            &:hover,
            &.active {
              background-color: #ffebf1;
              box-shadow: 0px 0px 1px 1px #a8032b inset;
              color: #a8032b;
            }

            &.active {
              background: url("./img/icon_rect_selected.png") no-repeat bottom
                right;
              background-size: 0.25rem;
            }
          }

          li.bg_gray {
            background-color: #f5f5f5;
            color: #ccc;

            &:hover {
              cursor: default;
              background-color: #f5f5f5;
              box-shadow: none;
              color: #ccc;
            }
          }
        }
      }
    }
  }

  //竞猜说明
  .guess_prize_remark {
    clear: both;
    width: 14rem;
    overflow: hidden;
    padding: 0.4rem 0px;
    margin: 0 auto;

    h3 {
      clear: both;
      width: 100%;
      height: 0.4rem;
      overflow: hidden;
      font-size: 0.24rem;
      color: #fff;
    }

    p {
      clear: both;
      width: 100%;
      line-height: 0.3rem;
      overflow: hidden;
      font-size: 0.18rem;
      color: #d9d9d9;
    }
  }
}
</style>
